import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceErr } from '../../services/VideoService';
import { DeviceVideoErrResponse } from '../../types/Videos';

function useGetVideoErr(
  deviceId: string,
  enabled: boolean = true,
): UseQueryResult<DeviceVideoErrResponse> {
  return useQuery(
    ['device-config', deviceId, enabled],
    async (): Promise<DeviceVideoErrResponse> => getDeviceErr(deviceId),
    {
      retry: 1,
      retryDelay: 3000,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled,
      refetchInterval: 3000, // ✅ poll every 3 seconds
    },
  );
}

export default useGetVideoErr;
